import { useForm as useFormInstance, useWatch, useWatchField } from '../../hooks/form';
import { FormGroup } from './FormGroup';
import { FormItem } from './FormItem';
import { Form as FormComp } from './Form';
import { FormRepeat } from './FormRepeat';
import { FormRepeatItem } from './FormRepeatItem';
import { withField } from './withField';
import { useForm } from './useForm';
import { withForm } from './withForm';
export var Form = Object.assign(FormComp, {
  Group: FormGroup,
  Item: FormItem,
  Repeat: FormRepeat,
  RepeatItem: FormRepeatItem,
  withField: withField,
  withForm: withForm,
  useForm: useForm,
  useFormInstance: useFormInstance,
  useWatch: useWatch,
  useWatchField: useWatchField
});
export { Form as FormInstanceType } from '../../hooks/form';